import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

/**
 * Component wrapper that ensures user_id is preserved in URL across all routes
 * This component should wrap all protected routes
 */
const RouteWithUserId = ({ children, requiredUserId = false }) => {
  const location = useLocation()
  const navigate = useNavigate()
  
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const userId = urlParams.get('user_id')
    
    
    // Check if user is logged in via localStorage
    const storedUser = localStorage.getItem('user')
    const hasStoredUser = storedUser && JSON.parse(storedUser)
    
    // If user_id is required but not present, but we have a stored user, preserve it
    if (requiredUserId && !userId && hasStoredUser) {
      const userData = JSON.parse(storedUser)
      const newUrl = `${location.pathname}?user_id=${userData.id}`
      navigate(newUrl, { replace: true })
      return
    }
    
    // If user_id is required but not present and no stored user, redirect to login
    if (requiredUserId && !userId && !hasStoredUser) {
      navigate('/auth/login')
      return
    }
    
    // If we have user_id, ensure it's preserved in the current URL
    if (userId && !location.search.includes('user_id')) {
      const newUrl = `${location.pathname}?user_id=${userId}`
      navigate(newUrl, { replace: true })
    }
  }, [location, navigate, requiredUserId])
  
  return <>{children}</>
}

export default RouteWithUserId
